package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

@Composable
fun BrandLoader(
    label: String = "Loading",
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = Modifier.classNames("sb-loader-root").then(modifier),
        contentAlignment = Alignment.Center,
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(28.px),
        ) {
            Image(src = "/logo.svg", modifier = Modifier.classNames("sb-loader-mark"))
            Box(modifier = Modifier.classNames("sb-loader-bar"))
            SpanText(text = label, modifier = Modifier.classNames("sb-loader-caption"))
        }
    }
}
